import React from "react";
import { RetailMatchMetricLevel } from "../../../../Enums/RetailMatchMetricLevel";
import { getRetailMatchIndexColor } from "../../../../Util/ColorUtil";
import { getRetailMatchMetricVerbiage } from "../../../../Util/RetailMatch/RetailMatchUtil";
import { BreakoutItemVerbiage } from "../Styled/RetailMatchIntroStyles";

interface IRetailMatchBreakoutItemWordProps {
  value: number;
  fontSize: number;
  metricLevel: RetailMatchMetricLevel;
}

const RetailMatchBreakoutItemWord = (
    props: IRetailMatchBreakoutItemWordProps
) => {
    return (
        <BreakoutItemVerbiage
            value={props.value}
            style={{
                fontSize: props.fontSize,
            }}
        >
            <span>
                <b style={{ color: getRetailMatchIndexColor(props.value) }}>
                    {getRetailMatchMetricVerbiage(props.value, props.metricLevel)}
                </b>
            </span>
        </BreakoutItemVerbiage>
    );
};

export default RetailMatchBreakoutItemWord;
